import { SplixerResourceInterface } from './splixer-resource.interface';
import { uNumber } from '@hidat/huijs-common';
import { ZonedDateTime } from '@js-joda/core';
import { ResourceConfig } from '@hidat/huijs-resource';

export const SessionStateConfig = new ResourceConfig(
  'SessionState',
  'session_states',
);

export interface SessionMasterStateInterface {
  seq_num?: number;
  scheduled_at?: string;
}

export interface SessionStateInterface extends SplixerResourceInterface<number> {
  playbackSessionId: uNumber;
  masterState: SessionMasterStateInterface | undefined;
  lastScheduledAt: ZonedDateTime | undefined;
  lastPlayStartedAt: ZonedDateTime | undefined;
  lastPlayFinishedAt: ZonedDateTime | undefined;
  playingScheduleLogId: uNumber;
  playingSeqNum: uNumber;
  instanceId: number | undefined;
}
